import React from 'react';
import styled from 'styled-components';

const StatusTileWrapper = styled.div`
  flex-direction: column;
`;

const StatusTile = styled.div`
  background-color: #256fef;
  color: #fff;
  margin: 1rem 0 0;
  border-radius: 0.4rem;
  padding: 0.5rem 0.8rem;
  font-weight: 500;
  font-size: 1.2rem;
`;

const LastUpdatedText = styled.div`
  flex-direction: column;
  font-size: 1.2rem;
  justify-content: flex-end;
  align-items: flex-end;
  color: #4f4f4f;
`;

export const MapStatusTile = React.memo(({ lastUpdatedAt }) => {
  const lastLocationUpdateTs = new Date(lastUpdatedAt);
  let isoDate = new Date(
    lastLocationUpdateTs.getTime() -
      lastLocationUpdateTs.getTimezoneOffset() * 60000,
  ).toISOString();
  return (
    <StatusTileWrapper>
      {/* <StatusTile>{statusMessage}</StatusTile> */}
      {lastUpdatedAt && (
        <LastUpdatedText>
          Valet location last updated at{' '}
          {new Date(isoDate).toLocaleTimeString()}
        </LastUpdatedText>
      )}
    </StatusTileWrapper>
  );
});
